/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiConversionFromJSON, ApiConversionToJSON, } from './ApiConversion';
import { ApiOperatorFromJSON, ApiOperatorToJSON, } from './ApiOperator';
import { ApiSessionConditionCustomFromJSON, ApiSessionConditionCustomToJSON, } from './ApiSessionConditionCustom';
import { ApiSessionEffectivenessConditionGroupFromJSON, ApiSessionEffectivenessConditionGroupToJSON, } from './ApiSessionEffectivenessConditionGroup';
export function ApiSessionEffectivenessConditionFromJSON(json) {
    return ApiSessionEffectivenessConditionFromJSONTyped(json, false);
}
export function ApiSessionEffectivenessConditionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'conditionGroup': !exists(json, 'conditionGroup') ? undefined : ApiSessionEffectivenessConditionGroupFromJSON(json['conditionGroup']),
        'conditionGroupId': !exists(json, 'conditionGroupId') ? undefined : json['conditionGroupId'],
        'conversion': !exists(json, 'conversion') ? undefined : ApiConversionFromJSON(json['conversion']),
        'conversionId': !exists(json, 'conversionId') ? undefined : json['conversionId'],
        'custom': !exists(json, 'custom') ? undefined : ApiSessionConditionCustomFromJSON(json['custom']),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'operator': !exists(json, 'operator') ? undefined : ApiOperatorFromJSON(json['operator']),
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}
export function ApiSessionEffectivenessConditionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'conditionGroup': ApiSessionEffectivenessConditionGroupToJSON(value.conditionGroup),
        'conditionGroupId': value.conditionGroupId,
        'conversion': ApiConversionToJSON(value.conversion),
        'conversionId': value.conversionId,
        'custom': ApiSessionConditionCustomToJSON(value.custom),
        'id': value.id,
        'operator': ApiOperatorToJSON(value.operator),
        'value': value.value,
    };
}
